export default "__VITE_ASSET__BvCtR30Y__"